import { DetailTab } from '@features/TagList/tagDetailSlice';

class LocalStore {
  private accessTokenKey = import.meta.env.VITE_ACCESS_TOKEN_SECRET;
  private refreshTokenKey = import.meta.env.VITE_REFRESH_TOKEN_SECRET;
  private userIdKey = import.meta.env.VITE_USER_ID_SECRET;
  private languageKey = import.meta.env.VITE_LANGUAGE_SECRET;
  private callingTagKey = import.meta.env.VITE_CALLING_TAG_SECRET;
  private currentTabKey = import.meta.env.VITE_CURRENT_TAB_SECRET;

  getAllCurrentTabs(): DetailTab[] {
    const tabs = localStorage.getItem(this.currentTabKey);
    return tabs ? JSON.parse(tabs) : [];
  }

  setAllCurrentTabs(tabs: DetailTab[]) {
    localStorage.setItem(this.currentTabKey, JSON.stringify(tabs));
  }

  getCallingTag(): string[] {
    const tagIds = localStorage.getItem(this.callingTagKey);
    return tagIds ? JSON.parse(tagIds) : [];
  }

  setCallingTag(tagIds: string[]) {
    localStorage.setItem(this.callingTagKey, JSON.stringify(tagIds));
  }

  getLanguage() {
    return localStorage.getItem(this.languageKey);
  }

  setLanguage(lang: string) {
    localStorage.setItem(this.languageKey, lang);
  }

  getUserId() {
    const id = localStorage.getItem(this.userIdKey);
    return id ? Number(id) : undefined;
  }

  setUserId(id: number | string) {
    localStorage.setItem(this.userIdKey, String(id));
  }

  deleteUserId() {
    localStorage.removeItem(this.userIdKey);
  }

  getTokens() {
    return {
      accessToken: this.getAccessToken(),
      refreshToken: this.getRefreshToken(),
    };
  }

  setTokens(tokens: { accessToken: string; refreshToken: string }) {
    this.setAccessToken(tokens.accessToken);
    this.setRefreshToken(tokens.refreshToken);
  }

  clearTokens() {
    this.removeAccessToken();
    this.removeRefreshToken();
  }

  private getAccessToken(): string | null {
    return localStorage.getItem(this.accessTokenKey);
  }
  private setAccessToken(accessToken: string) {
    localStorage.setItem(this.accessTokenKey, accessToken);
  }

  private removeAccessToken() {
    localStorage.removeItem(this.accessTokenKey);
  }

  private getRefreshToken(): string | null {
    return localStorage.getItem(this.refreshTokenKey);
  }
  private setRefreshToken(refreshToken: string) {
    localStorage.setItem(this.refreshTokenKey, refreshToken);
  }

  private removeRefreshToken() {
    localStorage.removeItem(this.refreshTokenKey);
  }
}

export default new LocalStore();
